import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_SIGN_UP_FAILED_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
  ERROR_CODE: '',
});
const RECORD = generateSchema(TRACKING_SIGN_UP_FAILED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_SIGN_UP_FAILED_SCHEMA);

export class SignUpFailedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.sign_up_failed;
  }

  get properties() {
    return this.toJS();
  }
}
